import { DirectionsRenderer, DirectionsService } from "@react-google-maps/api";
import { Fragment, useState } from "react";
import { getCurrentLatLong } from "../../../utils/common-utils";

const HexGoogleDistance = ({ destination }) => {
  const [response, setResponse] = useState("");
  const { latitude, longitude } = getCurrentLatLong();

  return (
    <Fragment>
      {!response && (
        <DirectionsService
          options={{
            destination: {
              lat: destination.latitude,
              lng: destination.longitude,
            },
            origin: { lat: latitude, lng: longitude },
            travelMode: "DRIVING",
          }}
          callback={(response) => {
            setResponse(response);
          }}
        />
      )}

      {response && (
        <DirectionsRenderer
          directions={response}
          options={{
            polylineOptions: {
              strokeColor: "#1a73e8",
              strokeOpacity: 3,
              strokeWeight: 3,
            },
            icon: { scale: 1 },
          }}
        />
      )}
    </Fragment>
  );
};

export default HexGoogleDistance;
